import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '../../modulos/login/login.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(private router: Router) {}

  canActivate(_ruta: unknown, estado: RouterStateSnapshot) {
    return this.chequearSesion(estado.url);
  }

  canActivateChild(_ruta: unknown, estado: RouterStateSnapshot) {
    return this.chequearSesion(estado.url);
  }

  // Sin token manda a login, pero recordando a dónde iba. Así un deep link
  // (una vista puntual configurada en una escena de videowall, un link compartido)
  // no se pierde al pasar por la pantalla de login.
  private chequearSesion(url: string): boolean | UrlTree {
    if (LoginService.getToken()) {
      return true;
    }
    return this.router.createUrlTree(['/login'], {
      queryParams: url && url !== '/' ? { returnUrl: url } : undefined,
    });
  }
}
